export default __webpack_public_path__ + "static/media/book.825daf1a.png";